enum RouteName {
  rootView = 'rootView',
  forbidden = 'forbidden',
  organizationView = 'organizationView',
  theOutdoorMappingView = 'theOutdoorMappingView',
  theMappingView = 'theMappingView',
  apiDocs = 'apiDocs',
}

export { RouteName }
